import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import NavigationMenu from './navigation-menu/navigationMenu';

const Menu: React.FC = () => {
	return (
		<BrowserRouter>
			<NavigationMenu/>
		</BrowserRouter>
	);
};

export default Menu;
